export enum ColorScheme {
  Dark = 'dark',
  Light = 'light',
}

export enum ThemeVariant {
  Default = 'default',
  Inverted = 'inverted',
  AsianStandard = 'asian',
  Deuteranopia = 'deuteranopia',
  Protanopia = 'protanopia',
}

export const themeVariants = Object.values(ThemeVariant);
export const colorSchemes = Object.values(ColorScheme);

export type ThemeName = `${ColorScheme}_${ThemeVariant}`;
export type DesignToken = `--${string}`;

export const DEFAULT_THEME: ThemeName = 'dark_default';

export const themeNames = colorSchemes.flatMap(scheme =>
  themeVariants.map(variant => `${scheme}_${variant}` as ThemeName)
);

export const accessibilityVariants = [
  ThemeVariant.Deuteranopia,
  ThemeVariant.Protanopia,
];
